<template>
<div class="chapter">
<div class="inner_page">
<p class="p9"><img alt="img1.png" height="696" src="images/img1.png" width="464"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?d6098cd8